import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class TableauReportsService {


  constructor(private http: HttpClient, private _api: ApiService, private sanitizer: DomSanitizer) { }
  imagePath: any;
  postId: string = "";
  errorMessage: string = "";
  site_id: string = ""; // stores site id when tablue server is loged in
  auth_token: string = ""; // stores authntication token which comes from tableau
  c_name: string = "";
  res: any = [];
  tableauEditDetails: any = [];
  tableauEditReferenceId:any;
  workbook_id: string = '';
  fileUrl: any;
  workbookid: string='';
  workbookname: string='';
  viewSiteId: any;
  wbwbid:any;
  // this funtion helps users to login in to tableau service
  login(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append('content-type', 'application/json')
    const body = JSON.stringify({ "credentials": { "name": "tabadmin", "password": "6StAqJv3L0q5", "site": { "contentUrl": "" } } });
    return this.http.post<any>('https://tableau.thesmartice.com/api/3.19/auth/signin', body, { headers })
  }
  // adminrefresh()
  // {
  //   let headers = new HttpHeaders();
  //   headers = headers.append('content-type', 'application/json')
  //   // console.log(this._api.curentuser);
  //   const body = ({ "credentials": { "name": "tabadmin", "password": "6StAqJv3L0q5", "site": { "contentUrl": "" } } });
  //   // console.log(body)
  //   return this.http.post(environment.JavaUrlEndPoint+'admin/Credentails/2',body, { headers })
  //   // .subscribe(
  //   //   (data:any)=>
  //   //     {
  //   //       console.log("user created succesfully")
  //   //       console.log(data);

  //   //     }
  //   //   );

  // }
  // /v1/admin/Credentails/{adminid}"
  // this function helps in getting views of a specific workbook
  views_list(workbook_id: string, site_id: string, auth_token: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append('content-type', 'application/json')
    headers = headers.append('X-Tableau-Auth', auth_token)
    return this.http.get<any>("https://tableau.thesmartice.com/api/3.19/sites/" + site_id + "/workbooks/" + workbook_id + "/views", { headers })
  }

  // this function helps user getting versions of the specific woprkbook
  versions_list(workbook_id: string, site_id: string, auth_token: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append('content-type', 'application/json')
    headers = headers.append('X-Tableau-Auth', auth_token)
    return this.http.get<any>("https://tableau.thesmartice.com/api/3.19/sites/" + site_id + "/workbooks/" + workbook_id + "/revisions", { headers })

  }

  // this funtion helps user to download a spefic workbook
  download_report(workbook_id: string, workbook_name: any,viewid:any,pagetype:any) {

    // this.getToken().subscribe((auth_token:any)=>{

      // this.auth_token=auth_token
      console.log(this._api.auth_token)
    const params = new HttpParams()
      .set('site_id', this.site_id)
      .set('token', this.auth_token)
      .set('workbook_id', workbook_id)
      .set('viewid',viewid)
      .set('downloadtype', "Landscape")
      .set('pagetype', "A4")
    this.http.get(environment.smartReportURL + 'downloadReport', { params: params, responseType: "blob" })
      .subscribe(
        (data) => {
          const source = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;${data}`;
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            window.URL.createObjectURL(blob)

          );
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `${workbook_name}.xlsx`;
          link.click();
         }
      )


    // let headers = new HttpHeaders();
    // headers = headers.append('content-type', 'application/xlsx')
    // headers = headers.append('X-Tableau-Auth', this._api.auth_token)
    // const formData: FormData = new FormData();
    // formData.append('site_id', this._api.site_id)
    // formData.append('auth_token', this._api.auth_token)
    // formData.append('workbook_id', workbook_id)
    // console.log("workbookid"+workbook_id);
    
      // console.log("In updateDownloadCount"+workbook_id)
      // console.log(workbook_id);
      // this.wbwbid=this._api.workbooksList.filter(x=>x.id===workbook_id).map(x=>x.id)
      // console.log(this.wbwbid);
      // this._api.updateDownloadCount(workbook_id);
  }

  // this funtion helps in geting token for displaying report
  getToken(): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('username', 'tabadmin');
    return this.http.post(environment.smartReportURL + 'getToken', formData, { responseType: 'text' as 'text' });
  }

  getViewIdSiteId(view_id: string, site_id: string, workbookName: string, i: any) {
    this.viewSiteId = { "view_id": view_id, "contentURL": workbookName, "site_id": this._api.site_id, "auth_token": this._api.auth_token, "i": i }
    console.log(this.viewSiteId.site_id)
  }


  // this funtion helps geting thumbnail of specefic workbook
  // getthumbnail(site_id: string, workbookid: string, token: string) {
  //   // console.log(workbookid)
  //   const formData: FormData = new FormData();
  //   formData.append('site_id', site_id);
  //   formData.append('workbook_id', workbookid);
  //   formData.append('token', token);
  //   const params = new HttpParams()
  //     .set('workbookid', workbookid)
  //   let headers = new HttpHeaders();
  //   headers = headers.append('content-type', 'image/png');
  //   headers = headers.append('X-Tableau-Auth', token);
  //   return this.http.get(environment.JavaUrlEndPoint + "getThumbnails", { params: params, responseType: 'blob' });
  // }

  connection_list(workbook_id: string, site_id: string, auth_token: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append('content-type', 'application/json')
    headers = headers.append('X-Tableau-Auth', auth_token)
    return this.http.get<any>("https://tableau.thesmartice.com/api/3.19/sites/" + site_id + "/workbooks/" + workbook_id + "/connections", { headers });
  }
}
